<div class="row">
    <div class="col-sm-11">
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Name</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.name" [disabled]="customerID > 0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Address</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.address1" [disabled]="customerID > 0" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Address 2</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.address2" [disabled]="customerID > 0" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">City</label>
            </div>
            <div class="col-sm-9">
                <city-state-zip-dropdown [parentForm]="customerForm" [ctrlName]="'cityStateZipCtrl'" [placeholder]="'Select a City'"
                                         (citySelected)="citySTChanged($event)" [cityID]="customer.cityId"
                                         [isDisabled]="customerID > 0" [isRequired]="true"></city-state-zip-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Time Zone</label>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="timeZoneName" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <label class="font-weight-bold">Lat/Lon</label>
                <button (click)="getCoords()" class="btn btn-sml btn-success" title="Get Coordinates" tabindex="-1" *ngIf="customer.cityId!=0"><i class="fas fa-search-location"></i></button>
            </div>
            <div class="col-sm-9">
                <input type="text" class="form-control" [(ngModel)]="customer.latitude" [disabled]="true" />
                <input type="text" class="form-control" [(ngModel)]="customer.longitude" [disabled]="true" />
            </div>
        </div>
        <!--<div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Sales Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="salesRep" [(ngModel)]="customer.salesEmployeeId" class="form-select">
                <option *ngFor="let rep of salesReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Ops Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="opsRep" [(ngModel)]="customer.opsRepId" class="form-select">
                <option *ngFor="let rep of opsReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Account Rep</label>
        </div>
        <div class="col-sm-9">
            <select name="accountRep" [(ngModel)]="customer.accountRepId" class="form-select">
                <option *ngFor="let rep of accountReps" value="{{rep.employeeId}}">{{rep.fullName}}</option>
            </select>
        </div>
    </div>-->
        <div class="row">
            <div class="col">
                <input type="checkbox" [(ngModel)]="customer.billToInd" [disabled]="customerID > 0" /> Bill To
                <input type="checkbox" [(ngModel)]="customer.shipperInd" [disabled]="customerID > 0" /> Shipper
                <input type="checkbox" [(ngModel)]="customer.consigneeInd" [disabled]="customerID > 0" /> Consignee
            </div>
        </div>
        <!--<div class="row" *ngIf="contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Phone</label>
        </div>
        <div class="col-sm-5">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.phone"></kendo-maskedtextbox>
        </div>
        <div class="col-sm-2">
            <label class="font-weight-bold">Ext</label>
        </div>
        <div class="col-sm-2">
            <input type="text" class="form-control" [(ngModel)]="customer.phoneExt" />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <label class="font-weight-bold">Cell</label>
        </div>
        <div class="col-sm-9">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.cell"></kendo-maskedtextbox>
        </div>
    </div>
    <div class="row" *ngIf="contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Fax</label>
        </div>
        <div class="col-sm-9">
            <kendo-maskedtextbox [mask]="phoneMask" class="form-control" type="text" [(ngModel)]="customer.fax"></kendo-maskedtextbox>
        </div>
    </div>
    <div class="row" *ngIf="contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Email</label>
        </div>
        <div class="col-sm-9">
            <input type="text" class="form-control" [(ngModel)]="customer.email" />
        </div>
    </div>
    <div class="row" *ngIf="contactTitleID!=3">
        <div class="col-sm-3">
            <label class="font-weight-bold">Default</label>
        </div>
        <div class="col-sm-9">
            <input type="checkbox" [(ngModel)]="customer.defaultContactInd" style="transform:scale(1.5);" />
        </div>
    </div>-->
        <div class="row" *ngIf="customerID > 0 && customerType != 'lead'">
            <div class="col-sm-12">
                <customer-team-assigned [customerID]="customerID" [pageType]="'add customer'"></customer-team-assigned>
            </div>
        </div>
    </div>
    <div class="col-sm-1" *ngIf="customerID > 0">
        <button type="button" class="btn btn-secondary" title="Close" (click)="close()"><i class="fas fa-times "></i></button>
    </div>
</div>
<div class="row" *ngIf="customerID == 0">
    <div class="col-sm-12 m-2">
        <button class="btn btn-primary m-2" (click)="saveCustomer()">Save</button>
        <button class="btn btn-secondary m-2" (click)="cancelCustomer()">Cancel</button>
    </div>
</div>
